module.exports = __webpack_public_path__ + "img/赵瑞鑫.d582681f.jpg";